import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import s from "../modules/MyDescriptions.module.css";
import { useT, useI18nReady } from "../components/TextProvider";

const TUSHUNCHALAR_ENDPOINT =
  process.env.REACT_APP_TUSHUNCHALAR_ENDPOINT ||
  "https://apitr.subxonqulov.uz/api/tushunchalar/";

const VAZIFALAR_ENDPOINT =
  process.env.REACT_APP_VAZIFALAR_ENDPOINT ||
  "https://apitr.subxonqulov.uz/api/vazifalar/";

// ===== helpers
function getStoredUser() {
  const ls = window.localStorage.getItem("auth:user");
  const ss = window.sessionStorage.getItem("auth:user");
  const raw = ls ?? ss;
  if (!raw) return null;
  try { return JSON.parse(raw); } catch { return null; }
}
function getAnyTokenFromStorage() {
  const pick = (s) =>
    s.getItem("auth:access") || s.getItem("auth:token") || s.getItem("auth:key") ||
    s.getItem("auth:jwt") || s.getItem("auth:auth_token") || null;
  return pick(window.localStorage) || pick(window.sessionStorage);
}
function makeAuthHeader(tokenLike) {
  if (!tokenLike) return {};
  const token = String(tokenLike);
  const forcedScheme = process.env.REACT_APP_AUTH_SCHEME;
  if (forcedScheme) return { Authorization: `${forcedScheme} ${token}` };
  const looksLikeJwt = token.startsWith("eyJ");
  return looksLikeJwt ? { Authorization: `Bearer ${token}` } : { Authorization: `Token ${token}` };
}

// ===== component
export default function MyDescriptions() {

  const t = useT();
  const ready = useI18nReady();

  const user = useMemo(() => getStoredUser(), []);
  const [items, setItems] = useState([]);
  const [vazifalar, setVazifalar] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!user?.id) {
      setItems([]);
      setVazifalar({});
      setLoading(false);
      return;
    }
  
    const ac = new AbortController();
    (async () => {
      setLoading(true);
      setError("");
  
      try {
        const token = getAnyTokenFromStorage();
        const headers = { ...makeAuthHeader(token) };
  
        // 1) Берём ВСЕ задания текущего пользователя
        const vazifalarRes = await fetch(
          `${VAZIFALAR_ENDPOINT}?user=${encodeURIComponent(user.id)}`,
          { headers, credentials: "include", signal: ac.signal }
        );
        const vazifalarData = await vazifalarRes.json().catch(() => []);
        const myVazifalar = Array.isArray(vazifalarData) ? vazifalarData : [];
        const allowedIds = new Set(myVazifalar.map(v => v.id));
  
        // Если у пользователя нет заданий — нет и его tushunchalar
        if (!allowedIds.size) {
          setVazifalar({});
          setItems([]);
          setLoading(false);
          return;
        }
  
        // 2) Берём tushunchalar и фильтруем по allowedIds
        const tushRes = await fetch(TUSHUNCHALAR_ENDPOINT, {
          headers, credentials: "include", signal: ac.signal
        });
        const tushData = await tushRes.json().catch(() => []);
        const list = (Array.isArray(tushData) ? tushData : [])
          .filter(it => allowedIds.has(it.vazifa));
  
        // 3) Справочник по заданиям (для названий)
        const map = {};
        myVazifalar.forEach(v => { map[v.id] = v; });
  
        // (необязательно) отсортируем по дате
        list.sort((a, b) =>
          new Date(b?.created_at || 0) - new Date(a?.created_at || 0)
        );
  
        setVazifalar(map);
        setItems(list);
      } catch (e) {
        if (!ac.signal.aborted) {
          setError("Ma'lumotlarni yuklashda xatolik yuz berdi");
          setItems([]);
          setVazifalar({});
        }
      } finally {
        if (!ac.signal.aborted) setLoading(false);
      }
    })();
  
    return () => ac.abort();
  }, [user?.id]);
  

  // async function handleDelete(id) {
  //   if (!window.confirm("Удалить описание?")) return;
  //   try {
  //     const token = getAnyTokenFromStorage();
  //     const res = await fetch(`${TUSHUNCHALAR_ENDPOINT}${id}/`, {
  //       method: "DELETE",
  //       headers: { ...(token ? makeAuthHeader(token) : {}) },
  //       credentials: "include",
  //     });
  //     if (res.ok) {
  //       setItems((prev) => prev.filter((i) => i.id !== id));
  //     } else {
  //       alert("Не удалось удалить описание");
  //     }
  //   } catch {
  //     alert("Ошибка при удалении");
  //   }
  // }

  function stripHtml(html) {
    const tmp = document.createElement("div");
    tmp.innerHTML = html || "";
    return tmp.textContent || tmp.innerText || "";
  }

  const filtered = items.filter((i) => {
    const text = stripHtml(i.matni).toLowerCase();
    return text.includes(search.toLowerCase());
  });

  return (
    <div className={s.wrapper}>
      <h1 className={s.title}>{t('myDesc')}</h1>
      {error && <div className={s.error}>{error}</div>}
      {loading ? (
        <div>Yuklanmoqda…</div>
      ) : (
        <>
          <input
            className={s.search}
            placeholder={t('MyDescPoisk')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className={s.list}>
            {filtered.map((item) => (
              <div key={item.id} className={s.card}>
                <h3 className={s.cardTitle}>
                  {vazifalar[item.vazifa]?.name || `Mashq #${item.vazifa}`}
                </h3>
                <div className={s.cardText}>
                  {stripHtml(item.matni).slice(0, 200)}…
                </div>
                <div className={s.actions}>
                  <Link to={`/desc/${item.id}`} className={s.btn}>{t('ochish')}</Link>
                  {/* <button onClick={() => handleDelete(item.id)} className={s.btnDanger}>
                    Удалить
                  </button> */}
                </div>
              </div>
            ))}
            {!filtered.length && <div className={s.empty}>Tavsiflar yo'q</div>}
          </div>
        </>
      )}
    </div>
  );
}
